import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ open, onClose, children, width = 520, locked }) {
  useEffect(() => {
    if (!open) return;
    const h = e => { if (e.key === 'Escape' && !locked && onClose) onClose(); };
    window.addEventListener('keydown', h);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', h); document.body.style.overflow = ''; };
  }, [open, locked, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onClick={locked ? undefined : onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
        background: 'rgba(3,3,4,0.85)', backdropFilter: 'blur(12px)',
        animation: 'fadeIn .18s ease both',
      }}
    >
      <div
        className="modal-sheet"
        onClick={e => e.stopPropagation()}
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: width,
          maxHeight: '88vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          background: 'linear-gradient(160deg, var(--surface-2), var(--surface))',
          border: '1px solid var(--line-strong)',
          borderRadius: 'var(--r-xl)',
          boxShadow: 'var(--shadow-pop), var(--glow-red)',
          animation: 'popIn .22s var(--ease-out) both',
        }}
      >
        <div className="modal-drag-handle" />
        {children}
      </div>
    </div>,
    document.body
  );
}
